var hooxSliderReviewsElements = document.querySelectorAll(".hoox-how-to__items");
hooxSliderReviewsElements.forEach(function(hooxSliderReview) {
    const sectionId = hooxSliderReview.id; 
    new Swiper(hooxSliderReview, {
        loop: true,
        centeredSlides: false,
        breakpoints: {
            600: {
                slidesPerView: 1.25,
                slidesPerGroup: 1,
            },
            767: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
        pagination: {
            el: `.hoox-reviews__dots-${sectionId}`, // Unique pagination selector for each instance
            clickable: true,
        },
        navigation: {
            nextEl: `.hoox-swiper-arrow-next-${sectionId}`, // Unique navigation selector for each instance
            prevEl: `.hoox-swiper-arrow-prev-${sectionId}`,
        },
    });
});
